import { useFiltersProjects } from '@shared/api/filters-ws';
import { useMemo } from 'react';
import { FILTER_DROPDOWN_SIZES, FILTER_FIELD_PROJECTS } from '../consts';
import { SearchCheckboxFilterDropdown } from '../SearchCheckboxFilterDropdown';

interface FilterDropdownProps {
  selectedProjects: string[];
  onApply: (selectedProjects: string[]) => void;
  onClose: () => void;
}

export const FilterDropdown = ({ selectedProjects, onApply, onClose }: FilterDropdownProps) => {
  const { projects } = useFiltersProjects();

  const items = useMemo(() => {
    const uniqueValues = new Set<string>();

    projects.forEach(({ name, code }) => {
      const value = name || code;
      if (!value) return;
      uniqueValues.add(value);
    });

    return [...uniqueValues].map((value) => ({ value, label: value }));
  }, [projects]);

  return (
    <SearchCheckboxFilterDropdown
      variant="compact"
      size={FILTER_DROPDOWN_SIZES[FILTER_FIELD_PROJECTS]}
      items={items}
      selectedValues={selectedProjects}
      onApply={onApply}
      onClose={onClose}
      selectAllLabel="Все проекты"
    />
  );
};
